// CMS GTM for Backgroun Image Selector
export const gtmEventTypes = {
  CLICK_IMAGE: 'CMS-BACKGROUNDIMAGESELECTOR-001',
}

export const gtmEvents = {
  [gtmEventTypes.CLICK_IMAGE]: ({CMSGroupGTM, imageName}) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.CLICK_IMAGE,
    event: 'reactjs.event',
    pageAction: `${CMSGroupGTM.action} - Clicked "${imageName.toUpperCase()}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/background-image-selector-duck.js